// @flow

/** @jsx h */

import { Component, h } from 'preact'
import { bem } from '@nrk/dh-utils'
import type { MenuItemType } from '../../types'
import { connect } from '../../../../lib/provider'
import styles from '../index.css'

type Props = {
  menuItem: MenuItemType,
  sendGaEvent: Function,
  current: boolean,
  preview: boolean
}

class Link extends Component<Props> {
  handleClick = () => {
    this.props.sendGaEvent({ action: 'click', label: this.props.menuItem.anchor })
  }

  render () {
    const { menuItem, current } = this.props
    return (
      <a
        href={menuItem.url}
        class={bem(styles.menu__item, { current })}
        onClick={this.handleClick}>
        {menuItem.text}
      </a>
    )
  }
}

export default connect(context => {
  if (context && context.sendGaEvent) {
    return { sendGaEvent: context.sendGaEvent }
  } else {
    return {}
  }
})(Link)



// WEBPACK FOOTER //
// ./src/v1/components/Menu/Link/index.js